export default __webpack_public_path__ + "nutricia-logo-education.17865fb.png";